import React from 'react'
import './HomeConnectCard.scss'

/*
  Шаг подключения — только текст. Кнопка заявки живёт под сеткой шагов,
  в строке действий секции: читать шаги и действовать — разные вещи.
*/
const HomeConnectCard = ({ id, title, subTitle }) => {
  return (
    <div className='homeConnectCard_block'>
      <div className="homeConnectCard_number">{id}</div>
      <h3 className="homeConnectCard_title">{title}</h3>
      <p className="homeConnectCard_text">{subTitle}</p>
    </div>
  )
}

export default HomeConnectCard
